var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-card',{staticClass:"card"},[_c('img',{attrs:{"src":require("@/assets/MySideline_PrimaryLogo_black.svg")}}),_c('h3',[_vm._v("Under Construction")]),_c('p',[_vm._v("We're working to bring you more and better features.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }